import MojitoModules from 'mojito/modules';

import {isLightColor} from '#core/utils/color-utils.js';

import {registerTileSchema} from '#core/application/schema-registry.js';

import {AbstractVisualFeature} from '../../../visual-feature.js';
import {ClassicCards} from '../classic-cards.js';

import {preBuiltCardsFactory} from './pre-built-cards.factory.js';

import PREBUILT_CARD_DETAILS from './prebuilt-card-details.palette-schema.yaml';
import PALETTE_SCHEMA from './pre-built-cards.palette-schema.yaml';

registerTileSchema(PREBUILT_CARD_DETAILS);

const {COLOR_MODES} = MojitoModules.EventCards.types;

class PreBuiltCardsFeature extends AbstractVisualFeature {
    get name() {
        return 'PreBuiltCards';
    }

    get paletteSchema() {
        return PALETTE_SCHEMA;
    }

    getSerializableVisualConfig(PALETTE) {
        const COLOR_MODE = isLightColor(PALETTE.PARENT.CARD_CONTAINER_BG, true) ? COLOR_MODES.LIGHT : COLOR_MODES.DARK;

        return preBuiltCardsFactory(PALETTE, COLOR_MODE);
    }
}

new PreBuiltCardsFeature(ClassicCards);
